export default __webpack_public_path__ + "static/media/FunctionalStrengthStatistics.976c3c10.png";